<form role="form" *ngIf="attachmentForm" [formGroup]="attachmentForm">
  <div class="row" *ngIf="isPersonaJuridica == false">

    <div class="col-12">
      <div class="alert alert-danger" role="alert">
        Apreciado ciudadano! En caso de contar con dos o más títulos universitarios favor separarlos por coma en orden cronológico, así mismo
        en el campo donde se deben adjuntar los soportes, favor subir un solo PDF con los títulos registrados según sea pregrado o postgrado.
      </div>
    </div>

    <div class="col-sm-12 col-md-4">
      <div class="entradas-de-texto-govco">
        <label for="tipoProgramaId">Tipo de Programa<span class="required">*</span></label>
        <select class="form-select" id="tipoProgramaId" aria-label="Default select example"
                formControlName="programTypeId" aria-describedby="programTypeId-note"
                [ngClass]="{'error': isTouchedField(attachmentForm, 'programTypeId')}"
                (change)="getListaDocumentosASubir()">
          <option value="" selected disabled>Seleccione</option>
          <option *ngFor="let item of programTypes" [value]="item.id">{{ item.description }}</option>
        </select>
        <span
              class="error-texto-govco alert-entradas-de-texto-govco" id="programTypeId-note" role="alert" aria-live="assertive">
          {{ getErrorMessage('programTypeId') }}
        </span>
      </div>
    </div>

    <div class="col-sm-12 col-md-4">
      <div class="entradas-de-texto-govco">
        <label for="tipoTitulo">Tipo Título<span class="required">*</span></label>
        <select class="form-select" id="tipoTitulo" aria-label="Default select example"
                formControlName="titleTypeId" aria-describedby="titleTypeId-note"
                [ngClass]="{'error': isTouchedField(attachmentForm, 'titleTypeId')}"
                (change)="getListaDocumentosASubir()">
          <option value="" selected disabled>Seleccione</option>
          <option *ngFor="let item of titleTypes" [value]="item.id">{{ item.description }}</option>
        </select>
        <span
              class="error-texto-govco alert-entradas-de-texto-govco" id="titleTypeId-note" role="alert" aria-live="assertive">
          {{ getErrorMessage('titleTypeId') }}
        </span>
      </div>
    </div>

    <div class="col-sm-12 col-md-4" *ngIf="attachmentForm.get('programTypeId').value == '1' || attachmentForm.get('programTypeId').value == '3'">
      <div class="entradas-de-texto-govco">
        <label for="tipoProfesional">Tipo Profesional<span class="required">*</span></label>
        <select class="form-select" id="tipoProfesional" aria-label="Default select example"
                formControlName="typeProfessionalId" aria-describedby="typeProfessionalId-note"
                [ngClass]="{'error': isTouchedField(attachmentForm, 'typeProfessionalId')}">
          <option value="" selected disabled>Seleccione</option>
          <option *ngFor="let item of typeProfessional" [value]="item.id">{{ item.description }}</option>
        </select>
        <span
              class="error-texto-govco alert-entradas-de-texto-govco" id="typeProfessionalId-note" role="alert" aria-live="assertive">
          {{ getErrorMessage('typeProfessionalId') }}
        </span>
      </div>
    </div>

    <div class="col-sm-12 col-md-6" *ngIf="attachmentForm.controls['typeProfessionalId'].value == '4'">
      <div class="entradas-de-texto-govco">
        <label for="otherProfessionalName">Otro Tipo Profesional<span class="required">*</span></label>
        <input type="text" id="otherProfessionalName" placeholder="Otro Tipo Profesional"
               formControlName="otherProfessionalName" aria-describedby="otherProfessionalType-note"
               [ngClass]="{'error': isTouchedField(attachmentForm, 'otherProfessionalName')}"/>
        <span class="error-texto-govco alert-entradas-de-texto-govco"
              id="otherProfessionalType-note" role="alert" aria-live="assertive">
          {{ getErrorMessage('otherProfessionalName') }}
        </span>
      </div>
    </div>

    <div class="col-sm-12 col-md-6">
      <div class="entradas-de-texto-govco">
        <label for="titleProfessionalName">Título del programa (como aparece en el diploma)<span class="required">*</span></label>
        <input type="text" id="titleProfessionalName" placeholder="Titulo del programa"
               formControlName="titleProfessionalName" aria-describedby="titleProfessionalName-note"
               [ngClass]="{'error': isTouchedField(attachmentForm, 'titleProfessionalName')}"/>
        <span
              class="error-texto-govco alert-entradas-de-texto-govco" id="titleProfessionalName-note" role="alert" aria-live="assertive">
          {{ getErrorMessage('titleProfessionalName') }}
        </span>
      </div>
    </div>

    <div class="col-sm-12 col-md-6" *ngIf="attachmentForm.controls['programTypeId'].value == '3'">
      <div class="entradas-de-texto-govco">
        <label for="titleDoctorateName">Título del postgrado (como aparece en el diploma)<span class="required">*</span></label>
        <input type="text" id="titleDoctorateName" placeholder="Titulo del postgrado"
               formControlName="titleDoctorateName" aria-describedby="otherTypeProgram-note"
               [ngClass]="{'error': isTouchedField(attachmentForm, 'titleDoctorateName')}"/>
        <span
          class="error-texto-govco alert-entradas-de-texto-govco" id="otherTypeProgram-note" role="alert" aria-live="assertive">
          {{ getErrorMessage('titleDoctorateName') }}
        </span>
      </div>
    </div>

    <div class="col-12" *ngIf="attachmentForm.controls['programTypeId'].value == '3'">
      <div class="alert alert-danger" role="alert">
        ¡Respetado(a) Ciudadano(a)! El registro calificado y el pensum que debe adjuntar es del programa de especialización.
      </div>
    </div>

  </div>

  <!--SECCION PERSONA JURIDICA-->
  <div class="row" *ngIf="isPersonaJuridica == true">

    <div class="col-sm-12 col-md-12" *ngIf="isPersonaJuridica==true">
      <div class="entradas-de-texto-govco">
        <label for="entityAddress" class="form-label">Dirección de la entidad <span class="required">*</span></label>
        <div class="container-input-texto-govco">
          <textarea id="entityAddress" class="form-control" rows="1"
                    [ngClass]="{'error': isTouchedField(attachmentForm, 'entityAddress')}"
                    aria-describedby="entityAddress-note"
                    formControlName="entityAddress"
                    placeholder="Dirección de la entidad">
          </textarea>
        </div>
        <span
          class="error-texto-govco alert-entradas-de-texto-govco" id="entityAddresss-note" role="alert" aria-live="assertive">
          {{ getErrorMessage('entityAddress') }}
        </span>
      </div>
    </div>


    <div class="row text-center">
      <div class="col-md-6">
        <a href="https://tramitesenlinea.saludcapital.gov.co/tramitessds/assets/docs/formato_recurso_humano.pdf" target="_blank">
          <span class="govco-file-pdf" style="font-size: 48px"></span>
          <br>
          Descarga Formato Personas Vinculadas a prestación del servicio de SST
        </a>
      </div>

      <div class="col-md-6">
        <a href="https://tramitesenlinea.saludcapital.gov.co/tramitessds/assets/docs/formato_equipos.pdf" target="_blank">
          <span class="govco-file-pdf" style="font-size: 48px"></span>
          <br>
          Descarga Formato Equipos destinados al Servicio de SST
        </a>
      </div>
    </div>

  </div>

  <!--LISTADO DE DOCUMENTOS-->
  <div class="row">
    <div class="col-12">
      <div class="col-sm-12 col-md-8 mt-4" *ngFor="let document of listDocuments">
        <label for="inputDocument_{{document.id}}" class="label-carga-de-archivo-govco">{{document.description}}<span class="required">*</span></label>
        <div class="input-group mt-2 mb-1 ">
          <input type="file" class="form-control input-file-custom" id="inputDocument_{{document.id}}"
                 aria-describedby="inputFile_Aria" aria-label="Upload"
                 accept="application/pdf" (change)="checkSelectedFile($event, document.id)">
          <button class="btn btn-outline-secondary" type="button" id="inputDocAddDescri_{{document.id}}"
                  *ngIf="hasDocument(document.id)"
                  (click)="removeFileAdded(document.id)">
            <span class="govco-trash-alt"></span>
          </button>
        </div>
        <span class="text-validation-carga-de-archivo-govco"><small>Únicamente archivo en formato .pdf.</small></span>
        <br>
      </div>
    </div>
  </div>

</form>
